<template>
  <field-string
    v-model="iValue"
    v-bind="$attrs"
    :rules="iRules"
    type="number"
  />
</template>

<script>
import { useValidation } from '@/compositions/validation'
import FieldString from '../FieldString'

export default {
  name: 'FieldInteger',
  components: {
    FieldString
  },
  props: {
    rules: {
      type: [String, Object],
      default: () => ({})
    },
    value: {
      type: Number,
      default: null
    }
  },
  setup (props) {
    const { iRules } = useValidation(props, 'integer')

    return { iRules }
  },
  computed: {
    iValue: {
      get () {
        return this.value ? this.value.toString() : ''
      },
      set (val) {
        const parsed = parseInt(val)
        if (Number.isInteger(parsed)) {
          this.$emit('input', parsed)
        } else {
          this.$emit('input', null)
        }
      }
    }
  }
}
</script>
